import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
//import axios from 'axios'
import Login from '@/views/Login/Login.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue'
import Profile from '@/components/profile/Profile.vue'
import Categories from '@/components/categories/Categories.vue'
import Areas from '@/components/areas/Areas.vue'
import Componentes from '@/components/componentes/Componentes.vue'
import Productos from '@/components/productos/Productos.vue'
import Cif from '@/components/cif/Cif.vue'
import ProductosDetalle from '@/components/productos/ProductosDetalle.vue'
import Home from '@/components/home/Home.vue'
import TermsConditions from '@/components/termsConditions/TermsConditions.vue'
import UserManagement from '@/components/userManagement/UserManagement.vue'
import Reportes from '@/components/home/Reportes.vue'
import ResetPassword from '@/views/resetPassword/ResetPassword.vue'
import TerminosyCondiciones from '@/views/terminosCondiciones/terminos-y-condiciones.vue'
import Gastos from '@/components/gastos/Gasto.vue'
    const routes = [
        {
            path: '*',
            redirect: '/login'
        },

        {
            path: '/', 
            redirect: 'products',
            name: "dashboard", 
            component: Dashboard,
            meta:{requiredAuth:true},
            children:[
            {
                path: "profile", 
                name: "profile", 
                component: Profile
            },
            {
                path: "home", 
                name: "home", 
                component: Home
            },
            {
                path: "reportes",
                name: 'Reportes',
                component:Reportes
            },
            {
                path: "categories", 
                name: "categories", 
                component: Categories
            },
            {
                path: "areas", 
                name: "areas", 
                component: Areas
            },
            {
                path: "components", 
                name: "components", 
                component: Componentes                
            },
            {
                path: "terms-conditions", 
                name: "terms-conditions", 
                component: TermsConditions
            },
            {    
                            
                path: "products/", 
                name: "products", 
                component: Productos               
            },
            {    
                            
                path: "cif", 
                name: "cif", 
                component: Cif               
            },
            {    
                            
                path: "gasto", 
                name: "gasto", 
                component: Gastos               
            },
            {
                path: 'product-detail/:id/:paginado', 
                name: "productDetail", 
                component: ProductosDetalle               
            },
            {
                path: "user-management",
                name: "user-management",
                component: UserManagement
            }

            ]
        },
        {
            path: '/login', 
            name: 'login', 
            component: Login,
            beforeEnter: (to, from, next) => { 
                localStorage.clear()
                next();  
            } 
        },
        {
            path: '/reset-password', 
            name: 'reset-password', 
            component: ResetPassword
        },
        {
            path: '/terminos-y-condiciones',
            name: 'TerminosyCondiciones',
            component: TerminosyCondiciones
        },
        
    ]

    const router = new Router({
        routes,
        mode:'history'
    })
    router.beforeEach((to, from, next) => {
        if(to.matched.some(routes => routes.meta.requiredAuth)){
            if(localStorage.getItem('token')){
                next()
              }else{
                next('/login')
            }
        }else{
            next()
        }
        /*
            axios.get(`https://${localStorage.getItem('secret-word')}.backend.costea.com.co/categories`).then((response)=> {
                console.log(response.data)
                next();
            }).catch((error) => {
                console.log(error)
                next('/login')
            })
        }*/
    })

    export default router